import { createZodDto } from './zod';

import { z } from 'zod';

const createBrandDtoSchema = z.object({
  name: z.string().min(2),
});
export class CreateBrandDto extends createZodDto(createBrandDtoSchema) {}
